import { Checkbox as UICheckbox } from '@rocketlane/ui';
import styled from 'styled-components';
const StyledCheckbox = styled(UICheckbox)`
  &.rl-checkbox {
    height: 1rem;
    width: 1rem;
  }

  & + & {
    margin: 0;
  }
`;
const StyledCheckboxGroup = styled(UICheckbox.Group)``;
// Object.assign rather than a property assignment: styled-components 6.5 rewrites a
// styled component's `style` prop, so the styled Group is no longer assignable to the
// `Group` static hoisted off UICheckbox. Assigning through Object.assign lets the
// resulting type carry the styled Group instead of the original's. Runtime is unchanged.
export const Checkbox = Object.assign(StyledCheckbox, {
    Group: StyledCheckboxGroup
});
